import { injectable, inject } from '~/container'
import {
  PuFetchAbstract,
  PuFetchInstance,
  PuFetchRequestConfig,
} from '~/utility/http'
import { getUrlPrefix } from '../locales'

@injectable()
export abstract class PuLangFetch {
  @inject(PuFetchAbstract)
  protected puFetch: PuFetchInstance

  abstract fetch<T>(
    langCode: string,
    url: string,
    config?: PuFetchRequestConfig,
  ): Promise<T>

  abstract fallbackFetch<T>(
    langCode: string,
    url: string,
    config?: PuFetchRequestConfig,
  ): Promise<T>

  abstract getDomainName(): string
}

export class PuLangFetchInstance extends PuLangFetch {
  async fetch<T>(langCode: string, url: string, config = {}): Promise<T> {
    const prefix = getUrlPrefix(langCode)
    return this.puFetch.get(`${prefix}${url}`, config)
  }

  async fallbackFetch<T>(
    langCode: string,
    url: string,
    config: PuFetchRequestConfig = {},
  ): Promise<T> {
    const PREFIX = '/_/fallback'
    const langPrefix = getUrlPrefix(langCode)
    const fetchUrl = url.startsWith('http')
      ? url
      : `${PREFIX}${langPrefix}${url}`
    const method = config.method ? config.method.toUpperCase() : 'GET'

    switch (method) {
      case 'PATCH':
        return this.puFetch.patch(fetchUrl, config.data, config)
      case 'PUT':
        return this.puFetch.put(fetchUrl, config.data, config)
      case 'DELETE':
        return this.puFetch.delete(fetchUrl, config)
      case 'POST':
        return this.puFetch.post(fetchUrl, config.data, config)
      default:
        return this.puFetch.get(fetchUrl, config)
    }
  }

  getDomainName() {
    return window.location.hostname
  }
}
